import { AutoComplete } from 'antd';
import { makeValueSpec, readValueSpec } from 'src/_shared/services/job-sync/serde';

// The Bonus specialization of the rule-set result control. A bonus rule emits a bonus-NAME string as
// `{ literal: name }`; erin-connect resolves that name to a TieredBonus at write time. The control is a
// free-entry AutoComplete seeded with the company's tieredBonuses names — but it accepts any typed
// string, so a config whose literal isn't in the current tieredBonuses list still round-trips verbatim.
export default function BonusResultControl({ spec, onChange, tieredBonuses = [] }) {
	const { value } = readValueSpec(spec);
	const options = (tieredBonuses || [])
		.filter((b) => b && b.name)
		.map((b) => ({ value: b.name }));

	return (
		<AutoComplete
			value={value == null ? '' : String(value)}
			options={options}
			filterOption={(input, option) =>
				String(option.value).toLowerCase().includes(input.toLowerCase())
			}
			onChange={(name) => onChange(makeValueSpec('literal', name))}
			placeholder="bonus name"
			style={{ width: '100%' }}
		/>
	);
}
